









import { Component, Vue, Prop } from 'vue-property-decorator'
import BtnDefault from "@/components/UI/BtnDefault.vue";

@Component({
  name: 'ErrorFetchingData',
  components: {BtnDefault}
})

export default class ErrorFetchingData extends Vue {
  @Prop({type: String, required: true}) protected actionName!: any

  fetchData() {
    this.$store.dispatch(this.actionName)
  }
}
